import { createAction } from '@reduxjs/toolkit';
import { api } from '@/lib/trpc/client';

export const salesOrdersShopsRequestStarted = createAction('sales-orders-shops/request/started');
export const salesOrdersShopsRequestFailed = createAction('sales-orders-shops/request/failed');

export const salesOrdersShopsFetchSucceeded = createAction('sales-orders-shops/fetch/succeeded');

function getTrcpErrorMessage(error) {
  return error?.message || error?.data?.code;
}
export const fetchSalesOrdersShops = () => (dispatch, getState) => {
  dispatch(salesOrdersShopsRequestStarted());

  const state = getState();
  const userState = state.user;
  const { activeChain } = userState;

  return api.salesOrders.getSalesOrderShops
    .query({
      chain: activeChain,
    })
    .then(
      ({ result }) => {
        dispatch(salesOrdersShopsFetchSucceeded(result));
      },
      (error) => dispatch(salesOrdersShopsRequestFailed(getTrcpErrorMessage(error)))
    );
};

export const salesOrdersShopFetchSucceeded = createAction(
  'sales-orders-shops/fetch-single/succeeded'
);
export const fetchSalesOrdersShop = (shopId) => (dispatch, getState) => {
  dispatch(salesOrdersShopsRequestStarted());

  const state = getState();
  const userState = state.user;
  let { activeChain } = userState;

  return api.salesOrders.getSalesOrderShop
    .query({
      id: shopId,
      chain: activeChain,
    })
    .then(
      ({ result }) => {
        dispatch(salesOrdersShopFetchSucceeded(result));
      },
      (error) => dispatch(salesOrdersShopsRequestFailed(getTrcpErrorMessage(message)))
    );
};

export const salesOrdersShopEditSucceeded = createAction('sales-orders-shops/edit/succeeded');
export const editSalesOrdersShop = (shopId, updateData) => (dispatch, getState) => {
  dispatch(salesOrdersShopsRequestStarted());

  const state = getState();

  const userState = state.user;
  let { user, activeChain } = userState;

  const salesOrdersShopsState = state.salesOrdersShops;
  const { shop } = salesOrdersShopsState;

  const updatedShop = {
    ...shop,
    ...updateData,
  };

  return api.salesOrders.editSalesOrderShop
    .mutate({
      id: shopId,
      updateData,
      chain: activeChain,
    })
    .then(
      () => {
        dispatch(salesOrdersShopEditSucceeded(updatedShop));
      },
      (error) => dispatch(salesOrdersShopsRequestFailed(getTrcpErrorMessage(error)))
    );
};
